import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, LoadingController, Platform } from '@ionic/angular/lazy';
import { OrderService } from 'src/app/services/order.service';
import { CountryService } from 'src/app/services/country.service';
import { PersonPickerPage } from 'src/app/modals/person-picker/person-picker.page';
import { PersonService } from 'src/app/services/person.service';
import { OrganisationPickerPage } from 'src/app/modals/organisation-picker/organisation-picker.page';
import { OrganisationService } from 'src/app/services/organisation.service';
import { CountryPickerPage } from 'src/app/modals/country-picker/country-picker.page';
import { AffiliatePickerPage } from 'src/app/modals/affiliate-picker/affiliate-picker.page';
import moment from 'moment-timezone';
import { StorageService } from 'src/app/services/storage.service';
import { ConnectedAccountService } from 'src/app/services/connected-account.service';
import { APIService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';
import { ObserverService } from 'src/app/services/observer.service';
import { UserService } from 'src/app/services/user.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-order-edit',
    templateUrl: './order-edit.page.html',
    styleUrls: ['./order-edit.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderEditPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    moment = moment;
    params = {};
    user = null;
    @Input() order_id = null;
    order = null;
    countries = null;
    country = null;
    subdivisions = null;
    person_name = null;
    organisation = null;
    affiliates = null;
    affiliate = null;
    formatted_pickup_date = null;
    formatted_delivery_date = null;
    modal_css_class = '';
    date_modal_css_class = '';
    address_requires_first_name = true;
    address_requires_last_name = true;
    address_requires_line_1 = true;
    address_requires_locality = true;
    address_requires_subdivision = false;
    address_subdivision_label = "State / province / region / county";
    address_subdivision_label_changed = false;
    address_requires_postal_code = false;
    address_postal_code_label = "Postcode";
    address_requires_mobile_phone_number = true;

    order_pos_shipping_address_require_subdivision = true;
    order_pos_shipping_address_require_postal_code = true;

    // modal flags
    person_picker_modal_open = false;
    organisation_picker_modal_open = false;
    affiliate_picker_modal_open = false;
    country_picker_modal_open = false;
    date_picker_modal_open = false;

    constructor(
        private router: Router,
        private apiService: APIService,
        private authService: AuthService,
        public modalController: ModalController,
        private platform: Platform,
        public loadingController: LoadingController,
        public alertController: AlertController,
        private orderService: OrderService,
        private countryService: CountryService,
        private personService: PersonService,
        private organisationService: OrganisationService,
        private storageService: StorageService,
        private connectedAccountService: ConnectedAccountService,
        private observerService: ObserverService,
        private userService: UserService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
            this.date_modal_css_class = 'backdrop';
        }

        if(this.order_id) {


            this.loadData().then(() => {

                if(this.order.channel == 'point_of_sale') {

                    this.storageService.get('order_pos_shipping_address_require_first_name').then((order_pos_shipping_address_require_first_name) => {
                        if(order_pos_shipping_address_require_first_name) {

                            if(order_pos_shipping_address_require_first_name === 'true') {
                                this.address_requires_first_name = true;
                            } 
                            else {
                                this.address_requires_first_name = false;
                            }

                        }
                    });

                    this.storageService.get('order_pos_shipping_address_require_last_name').then((order_pos_shipping_address_require_last_name) => {
                        if(order_pos_shipping_address_require_last_name) {

                            if(order_pos_shipping_address_require_last_name === 'true') {
                                this.address_requires_last_name = true;
                            } 
                            else {
                                this.address_requires_last_name = false;
                            }

                        }
                    });

                    this.storageService.get('order_pos_shipping_address_require_line_1').then((order_pos_shipping_address_require_line_1) => {
                        if(order_pos_shipping_address_require_line_1) {

                            if(order_pos_shipping_address_require_line_1 === 'true') {
                                this.address_requires_line_1 = true;
                            } 
                            else {
                                this.address_requires_line_1 = false;
                            }

                        }
                    });

                    this.storageService.get('order_pos_shipping_address_require_locality').then((order_pos_shipping_address_require_locality) => {
                        if(order_pos_shipping_address_require_locality) {

                            if(order_pos_shipping_address_require_locality === 'true') {
                                this.address_requires_locality = true;
                            } 
                            else {
                                this.address_requires_locality = false;
                            }

                        }
                    });

                    this.storageService.get('order_pos_shipping_address_require_subdivision').then((order_pos_shipping_address_require_subdivision) => {
                        if(order_pos_shipping_address_require_subdivision) {

                            if(order_pos_shipping_address_require_subdivision === 'true') {
                                this.order_pos_shipping_address_require_subdivision = true;
                            } 
                            else {
                                this.order_pos_shipping_address_require_subdivision = false;
                            }

                        }
                    });

                    this.storageService.get('order_pos_shipping_address_require_postal_code').then((order_pos_shipping_address_require_postal_code) => {
                        if(order_pos_shipping_address_require_postal_code) {

                            if(order_pos_shipping_address_require_postal_code === 'true') {
                                this.order_pos_shipping_address_require_postal_code = true;
                            } 
                            else {
                                this.order_pos_shipping_address_require_postal_code = false;
                            }

                        }
                    });

                    this.storageService.get('order_pos_shipping_address_require_mobile_phone_number').then((order_pos_shipping_address_require_mobile_phone_number) => {
                        if(order_pos_shipping_address_require_mobile_phone_number) {

                            if(order_pos_shipping_address_require_mobile_phone_number === 'true') {
                                this.address_requires_mobile_phone_number = true;
                            } 
                            else {
                                this.address_requires_mobile_phone_number = false;
                            }

                        }
                    });

                }

                this.params['gift'] = this.order.gift;
                this.params['pickup'] = this.order.pickup;
                this.params['pickup_date'] = "";
                this.params['gift_message'] = "";
                this.params['affiliate_id'] = "";
                this.params['person_id'] = "";
                this.params['organisation_id'] = "";
                this.params["purchase_order_number"] = "";
                this.params["reference"] = "";
                this.params["special_instructions"] = "";
                this.params['customer_note'] = "";
                this.params['internal_note'] = "";
                this.params['shipping_address_first_name'] = "";
                this.params['shipping_address_last_name'] = "";
                this.params['shipping_address_organisation_title'] = "";
                this.params['shipping_address_premises'] = "";
                this.params['shipping_address_line_1'] = "";
                this.params['shipping_address_line_2'] = "";
                this.params['shipping_address_locality'] = "";
                this.params['shipping_address_subdivision'] = "";
                this.params['shipping_address_postal_code'] = "";
                this.params['shipping_address_country_id'] = "";
                this.params['shipping_address_mobile_phone_number'] = "";
                this.params['shipping_address_what3words_address'] = "";
                this.params['shipping_address_courier_instructions'] = "";
                this.params['shipping_notification_email_address'] = "";
                this.params['delivery_date'] = "";

                if(this.order.gift && this.order.gift_message) {
                    this.params['gift_message'] = this.order.gift_message;
                }

                if(this.order.pickup && this.order.pickup_date) {
                    this.params['pickup_date'] = this.moment.utc(this.order.pickup_date).tz(this.user.timezone.code).toISOString(true);
                    this.formatted_pickup_date = this.moment(this.params['pickup_date']).format("D MMM YYYY, HH:mm");
                }

                if(this.order.affiliate) {
                    this.affiliate = this.order.affiliate;
                    this.params['affiliate_id'] = this.order.affiliate.id;
                }

                if(this.order.purchase_order_number) {
                    this.params["purchase_order_number"] = this.order.purchase_order_number;
                }

                if(this.order.reference) {
                    this.params["reference"] = this.order.reference;
                }

                if(this.order.special_instructions) {
                    this.params["special_instructions"] = this.order.special_instructions;
                }

                if(this.order.customer_note) {
                    this.params['customer_note'] = this.order.customer_note;
                }

                if(this.order.internal_note) {
                    this.params['internal_note'] = this.order.internal_note;
                }

                if(this.order.shipping_notification_email_address) {
                    this.params['shipping_notification_email_address'] = this.order.shipping_notification_email_address;
                }

                if(this.order.person || this.order.organisation) {

                    if(this.order.person) {
                        this.params['person_id'] = this.order.person.id;
                        
                        // format person name for picker UI
                        if(this.order.person.full_name) {
                            this.person_name = this.order.person.full_name + ' (#' + this.order.person.number + ')';
                        }
                        else {
                            this.person_name = '#' + this.order.person.number;
                        }

                    }

                    if(this.order.organisation) {
                        this.organisation = this.order.organisation;
                        this.params['organisation_id'] = this.order.organisation.id;
                    }

                }

                if(this.order.shipping_address) {

                    if(this.order.shipping_address.first_name) {
                        this.params['shipping_address_first_name'] = this.order.shipping_address.first_name;
                    }
                    if(this.order.shipping_address.last_name) {
                        this.params['shipping_address_last_name'] = this.order.shipping_address.last_name;
                    }
                    if(this.order.shipping_address.organisation_title) {
                        this.params['shipping_address_organisation_title'] = this.order.shipping_address.organisation_title;
                    }
                    if(this.order.shipping_address.premises) {
                        this.params['shipping_address_premises'] = this.order.shipping_address.premises;
                    }
                    if(this.order.shipping_address.line_1) {
                        this.params['shipping_address_line_1'] = this.order.shipping_address.line_1;
                    }
                    if(this.order.shipping_address.line_2) {
                        this.params['shipping_address_line_2'] = this.order.shipping_address.line_2;
                    }
                    if(this.order.shipping_address.locality) {
                        this.params['shipping_address_locality'] = this.order.shipping_address.locality;
                    }
                    if(this.order.shipping_address.subdivision) {
                        this.params['shipping_address_subdivision'] = this.order.shipping_address.subdivision;
                    }
                    if(this.order.shipping_address.postal_code) {
                        this.params['shipping_address_postal_code'] = this.order.shipping_address.postal_code;
                    }

                    if(this.order.shipping_address.country) {
                        this.params['shipping_address_country_id'] = this.order.shipping_address.country.id;
                        this.loadCountry(this.order.shipping_address.country.id).then(() => {
                            this.countryChanged();
                        })
                        .catch(() => { });
                    }

                    if(this.order.shipping_address.mobile_phone_number) {
                        this.params['shipping_address_mobile_phone_number'] = this.order.shipping_address.mobile_phone_number;
                    }
                    if(this.order.shipping_address.what3words_address) {
                        this.params['shipping_address_what3words_address'] = this.order.shipping_address.what3words_address;
                    }
                    if(this.order.shipping_address.courier_instructions) {
                        this.params['shipping_address_courier_instructions'] = this.order.shipping_address.courier_instructions;
                    }

                }

                if(this.order.delivery_date) {
                    this.params['delivery_date'] = this.moment.utc(this.order.delivery_date).tz(this.user.timezone.code).toISOString(true);
                    this.formatted_delivery_date = this.moment(this.params['delivery_date']).format("D MMM YYYY");
                }

            })
            .catch(() => { });

        }

        this.observerService.subscribe('network_status_changed|order_edit_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => {} ).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to edit an order, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|order_edit_modal");
    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading order").then(() => {
                this.orderService.getOrder(this.order_id).then((order) => {
                    if(order) {
                        this.order = order;
                    }
                    this.loadUser().then(() => {
                        this.loading_spinner.message = "Loading affiliates";
                        this.loadAffiliates().then(() => {
                            this.loading_spinner.dismiss();
                            resolve();
                        })
                        .catch(() => {
                            this.loading_spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadUser() {
        return new Promise<void>((resolve, reject) => {
            this.user = null;
            this.storageService.get("connected_account_id").then((connected_account_id) => {
                if(connected_account_id) {
                    this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account) => {
                        if(connected_account['user_id']) {
                            this.userService.getUser(connected_account['user_id']).then((user) => {
                                this.user = user;
                            });
                        }
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
                }
            })
            .catch(() => {
                reject();
            });
        });
    }

    loadAffiliates() {
        let promise = new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.getAffiliates().then((affiliates) => {
                    if(affiliates) {
                        this.affiliates = affiliates;
                        for(let i = 0; i < this.affiliates.length; i++) {
                            if(this.order.affiliate && this.order.affiliate.id == this.affiliates[i].id) {
                                this.affiliate = this.affiliates[i];
                            }
                        }
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error.status === 400) {
                        this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to retrieve a list of affiliates.");
                    } 
                    else if(error.status === 403) {
                        this.presentAlert("Insufficient permissions", "You don't have permission to view affiliates.");
                    } 
                    else if(error.status == 404) {
                        this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve a list of affiliates at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
        return promise;
    }

    loadCountry(country_id) {
        const promise = new Promise<void>((resolve, reject) => {
            this.country = null;
            this.subdivisions = null;
            this.countryService.getCountry(country_id).then((country: any) => {
                this.country = country;
                if(country.subdivisions) {
                    this.subdivisions = country.subdivisions;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    countryChanged(){

        this.address_subdivision_label = "State / province / region / county";
        this.address_requires_subdivision = false;
        this.address_postal_code_label = "Postcode";
        this.address_requires_postal_code = false;

        if(this.params['shipping_address_country_id']) {

            if(this.country.subdivision_name) {
                this.address_subdivision_label = this.country.subdivision_name;
            }

            if(this.order_pos_shipping_address_require_subdivision && this.subdivisions && this.subdivisions.length != 0) {
                this.address_requires_subdivision = true;
            }

            if(this.country.postal_code_name) {
                this.address_postal_code_label = this.country.postal_code_name;
            }

            if(this.order_pos_shipping_address_require_postal_code && this.country.postal_code_required == true) {
                this.address_requires_postal_code = true;
            }

        }

        // NOTE: address_subdivision_label_changed is used to force UI to render correctly
        this.address_subdivision_label_changed = false;

        setTimeout(() => {
            this.address_subdivision_label_changed = true;
        }, 0);

    }

    close() {
        this.modalController.dismiss();
    }

    async update() {

        let validated = true;
        let email_address_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let parsed_what3words_address = null;

        // NOTE: if any parts of the shipping address are provided then validate
        if(this.params['shipping_address_first_name'] || this.params['shipping_address_last_name'] || this.params['shipping_address_organisation_title'] || this.params['shipping_address_country_id'] || this.params['shipping_address_premises'] || this.params['shipping_address_line_1'] || this.params['shipping_address_line_2'] || this.params['shipping_address_locality'] || this.params['shipping_address_subdivision'] || this.params['shipping_address_postal_code'] || this.params['shipping_address_what3words_address'] || this.params['shipping_address_courier_instructions'] || this.params['shipping_address_mobile_phone_number']) {

            if(this.params['shipping_address_what3words_address'] != null) {

                parsed_what3words_address = this.params['shipping_address_what3words_address'].trim();

                if(parsed_what3words_address.startsWith("///")) {
                    parsed_what3words_address = parsed_what3words_address.substring(3);
                }
                else if(parsed_what3words_address.toLowerCase().indexOf("what3words.com/") !== -1) {
                    parsed_what3words_address = parsed_what3words_address.replace(/https?:\/\/(?:www\.)?what3words\.com\/([a-z]+\.[a-z]+\.[a-z]+).*/i, "$1");
                }

            }

            if(this.address_requires_first_name && (this.params['shipping_address_first_name'] == null || this.params['shipping_address_first_name'].trim() === "")) {
                this.presentAlert("Missing first name", "Please enter a shipping address first name.");
                validated = false;
            }
            else if(this.address_requires_last_name && (this.params['shipping_address_last_name'] == null || this.params['shipping_address_last_name'].trim() === "")) {
                this.presentAlert("Missing last name", "Please enter a shipping address last name.");
                validated = false;
            }
            else if(this.params['shipping_address_country_id'] == null || this.params['shipping_address_country_id'].trim() === "") {
                this.presentAlert("Missing country", "Please select a shipping address country.");
                validated = false;
            }
            else {

                if(this.address_requires_line_1 && (this.params['shipping_address_line_1'] == null || this.params['shipping_address_line_1'].trim() === "")) {
                    this.presentAlert("Missing line 1", "Please enter a shipping address line 1.");
                    validated = false;
                }
                else if(this.address_requires_locality && (this.params['shipping_address_locality'] == null || this.params['shipping_address_locality'].trim() === "")) {
                    this.presentAlert("Missing town / city", "Please enter a shipping address town / city.");
                    validated = false;
                }
                else if(this.address_requires_subdivision && (this.params['shipping_address_subdivision'] == null || this.params['shipping_address_subdivision'].trim() === "")) {
                    this.presentAlert("Missing " + this.address_subdivision_label, "Please enter a shipping address " + this.address_subdivision_label + ".");
                    validated = false;
                }
                else if(this.address_requires_postal_code && (this.params['shipping_address_postal_code'] == null || this.params['shipping_address_postal_code'].trim() === "")) {
                    this.presentAlert("Missing " + this.address_postal_code_label, "Please enter a shipping address " + this.address_postal_code_label + ".");
                    validated = false;
                }
                else if(parsed_what3words_address !== "" && !/^[a-z]+\.[a-z]+\.[a-z]+$/i.test(parsed_what3words_address)) {
                    this.presentAlert("Invalid what3words address", "Please enter a valid shipping address what3words address.");
                    validated = false;
                }
                else if(this.address_requires_mobile_phone_number && (this.params['shipping_address_mobile_phone_number'] == null || this.params['shipping_address_mobile_phone_number'].trim() === "")) {
                    this.presentAlert("Missing mobile phone number", "Please enter a shipping address mobile phone number.");
                    validated = false;
                }

            }
        }

        if(this.params['shipping_notification_email_address'] && !email_address_regex.test(String(this.params['shipping_notification_email_address']).toLowerCase())) {
            this.presentAlert("Invalid shipping notification email address", "Please enter a valid shipping notification email address.");
            validated = false;
        }

        if(validated) {

            // NOTE: clear gift message if not a gift
            if(this.params['gift'] == false){
                this.params['gift_message'] = null;
            }

            // NOTE: clear pickup_date if not a pickup
            if(this.params['pickup'] == false) {
                this.params['pickup_date'] = null;
            }
            else if(this.params['pickup_date']) {
                this.params['pickup_date'] = this.moment(this.params['pickup_date']).utc().toISOString();
            }

            if(this.params['delivery_date']) {
                this.params['delivery_date'] = this.moment(this.params['delivery_date']).utc().toISOString();
            }

            if(parsed_what3words_address != null) {
                this.params['shipping_address_what3words_address'] = parsed_what3words_address;
            }

            this.updateOrder().then(() => {
                this.modalController.dismiss();
            });

        }

    }

    updateOrder() {
        return new Promise<void>((resolve, reject) => {
            this.presentSpinner("Updating order").then(() => {
                this.orderService.updateOrder(this.order.id, this.params).then(() => {
                    this.spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
    }

    async presentPersonPickerModal() {
        if(!this.person_picker_modal_open) {
            this.person_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: PersonPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    invoked_from: "order_edit_modal",
                    person_id: (this.params['person_id'] ? this.params['person_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.person_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "person_deleted") {
                        this.params['person_id'] = ""
                        this.person_name = null;
                    } 
                    else {
                        this.params['person_id'] = data.data['person_id'];
                        this.person_name = data.data['person_name'];
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentOrganisationPickerModal() {
        if(!this.organisation_picker_modal_open) {
            this.organisation_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: OrganisationPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    organisation_id: (this.params['organisation_id'] ? this.params['organisation_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.organisation_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "organisation_deleted") {
                        this.params['organisation_id'] = ""
                        this.organisation = null;
                    } 
                    else {
                        this.params['organisation_id'] = data.data['organisation_id'];
                        this.organisationService.getOrganisation(data.data['organisation_id'],{}).then((organisation) => {
                            if(organisation) {
                                this.organisation = organisation;
                            }
                        })
                        .catch(() => { });
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAffiliatePickerModal() {
        if(!this.affiliate_picker_modal_open) {
            this.affiliate_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: AffiliatePickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    affiliate_id: (this.params['affiliate_id'] ? this.params['affiliate_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.affiliate_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "affiliate_deleted") {
                        this.params["affiliate_id"] = "";
                        delete this.affiliate;
                    }
                    else {
                        this.params['affiliate_id'] = data.data['affiliate_id'];
                        for(let i = 0; i < this.affiliates.length; i++) {
                            if(this.affiliates[i].id == this.params['affiliate_id']) {
                                this.affiliate = this.affiliates[i];
                                break;
                            }
                        }
                    }

                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            let existing_shipping_address_country_id = "";
            if(this.params['shipping_address_country_id']) {
                existing_shipping_address_country_id = this.params['shipping_address_country_id'];
            }
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: (this.params['shipping_address_country_id'] ? this.params['shipping_address_country_id'] : "")
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "country_deleted") {
                        this.params['shipping_address_premises'] = "";
                        this.params['shipping_address_line_1'] = "";
                        this.params['shipping_address_line_2'] = "";
                        this.params['shipping_address_locality'] = "";
                        this.params['shipping_address_subdivision'] = "";
                        this.params['shipping_address_postal_code'] = "";
                        this.params['shipping_address_country_id'] = "";
                        this.country = null;
                        this.countryChanged();
                    }
                    else {
                        if(data.data['country_id'] != existing_shipping_address_country_id) {
                            this.params["shipping_address_country_id"] = data.data['country_id'];
                            this.loadCountry(data.data['country_id']).then(() => {
                                this.countryChanged();
                            })
                            .catch(() => { });
                        }
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentDeliveryDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['delivery_date'] ? this.params['delivery_date'] : ""),
                    format: "date",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        this.params['delivery_date'] = "";
                        this.formatted_delivery_date = null;
                    }
                    else {
                        this.params['delivery_date'] = data.data['date'];
                        this.formatted_delivery_date = this.moment(this.params['delivery_date']).format("D MMM YYYY");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentPickupDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['pickup_date'] ? this.params['pickup_date'] : ""),
                    format: "date-time",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        this.params['pickup_date'] = "";
                        this.formatted_pickup_date = null;
                    }
                    else {
                        this.params['pickup_date'] = data.data['date'];
                        this.formatted_pickup_date = this.moment(this.params['pickup_date']).format("D MMM YYYY, HH:mm");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}
